import React, { Component } from "react";
import BackgroundImage from "../../images/bg-image-2.jpg"

class PrivacyPolicyComponent extends Component {
    render() { 
        return (
           <div style={{"margin-left": "25%", "margin-right": "25%"}}>
            <h5><center>Privacy Policy</center></h5>
  <p>Effective Date: 01.10.2022.</p>
  <h6><center>Introduction</center></h6>
  <p>Atelje Stojčić is committed to protecting the privacy of individuals who use our web application for appointment reservation (further references as "Application"). This Privacy Policy (the "Policy") explains the types of personal data we collect, the purposes for which we use such personal data, and the measures we take to protect such personal data. By using the Application, you acknowledge that you have read and understand this Policy and that you consent to the collection, use, and sharing of your personal data as described in this Policy.</p>
  <h6><center>Scope</center></h6>
  <p>This Policy applies to all personal data that we collect, use, or process in connection with the Application.</p>
  <h6><center>Use of Personal Data</center></h6>
  <p>The system only accesses the necessary information needed to schedule appointments, such as the desired date and time, person name (doesn’t have to be a full name and user can put any kind of nickname), email and phone number.</p>
  <h6><center>Sharing of Personal Data</center></h6>
  <p>We do not share any personal data with third parties.</p>
  <h6><center>Data Security</center></h6>
  <p>We have implemented appropriate technical and organizational measures to protect the personal data that we collect and process. These measures are designed to provide a level of security appropriate to the risk of processing your personal data.</p>
  <h6><center>Changes to Our Privacy Policy</center></h6>
  <p>We may update our Privacy Policy from time to time. We will post any changes on this page and encourage you to review the Policy periodically for the latest information on our privacy practices.</p>
  <h6><center>Contact Us</center></h6>
  <p>If you have any questions or concerns about our Privacy Policy, please contact us at ateljestojcic.info@gmail.com.</p>
  <p>Thank you for using the Application.</p>
           </div> 
        );
    }
}
 
export default PrivacyPolicyComponent;